import { render } from "./index.vue?vue&type=template&id=24c42435&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=24c42435&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-24c42435"

export default script